import { AfterViewInit, Component, ElementRef, HostListener, Input, NgModule, OnInit, ViewChild } from '@angular/core';

 import { Chart,LineController, LineElement, PointElement, LinearScale, Title,CategoryScale, ScatterController, Tooltip, Legend, BarController, BarElement, Filler,PieController,ArcElement} from 'chart.js';

import ChartDataLabels from 'chartjs-plugin-datalabels';
import {ConfigLineChart} from './config'
@Component({
  selector: 'app-venta-marca-chart',
  templateUrl: './venta-marca-chart.component.html',
  styleUrls: ['./venta-marca-chart.component.css']
})
export class VentaMarcaChartComponent implements OnInit,AfterViewInit {
  @ViewChild('chartMarcas') canvas: ElementRef;
  public innerWidth: number;
  @Input()
  nameChart:string = 'line';
  @Input()
  typeChart:string;
  @Input()
  multi: any[];
  @Input()
  labels: string[];
  @Input()
  colors: string[];
  @Input()
  axis: string[];

  view: any[] = [, 750];
  myChart: Chart;
  // options
  legend: boolean = true;
  showLabels: boolean = true;
  animations: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = false;
  showYAxisLabel: boolean = false;
  showXAxisLabel: boolean = true;
  xAxisLabel: string = 'Mes';
  yAxisLabel: string = 'Ventas total';
  timeline: boolean = true;
  showDataLabel: boolean = true;

  optionsChart: any;
  // colorScheme = {
  //   domain: ['#152038', '#012C77', '#00000D', '#728C11', '#5F5F61', '#022055']
  // };
  //myChart: Chart;
  constructor() {
    //Object.assign(this, { multi });

    // Chart.register(LineController, Filler, BarController, BarElement, LineElement, PointElement, LinearScale, Title,CategoryScale, ScatterController, Tooltip, Legend,PieController,ArcElement);
  }

  ngOnInit() {
    this.optionsChart = ConfigLineChart;

  }
  ngAfterViewInit() {
    this.updateChart(0,this.multi,this.labels);
  }

  updateChart(val,dataset, months)
  {
    const labels = months;
    var dataChart = {};
    if(val == 1)
    {
      this.myChart.destroy();
    }
    dataChart = {
      labels: labels,
      datasets: dataset
    };

    this.generateChart(dataChart);
  }
  generateChart(dataChart)
  {
    debugger;
    this.optionsChart.indexAxis = this.axis;
    // this.myChart = new Chart(
    //   this.nameChart,{
    //     type:'line',
    //     data: dataChart,
    //     plugins:[ChartDataLabels,Tooltip],
    //     options: this.optionsChart
    //   }
    // );
    
  }
}